// import React, { useState, useEffect, useCallback } from 'react';
// import { Search, Download, RotateCcw, Filter } from 'lucide-react';
// import ApiHandlerSuperCoordinator from './apiHandlerSuperCoordinator';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// export default function PatientRecordsSearch() {
//   const [filters, setFilters] = useState({
//     patientName: '',
//     startDate: '',
//     endDate: '',
//     receivedStartDate: '',
//     receivedEndDate: '',
//     modality: [],
//     radiologist: [],
//     status: 'All',
//     institution: []
//   });

//   const [searchTerms, setSearchTerms] = useState({
//     radiologist: "",
//     institution: "",
//     modality: ""
//   });

//     const [frontendSearch, setFrontendSearch] = useState({
//     patientId: '',
//     patientName: ''
//   });
//   const [patients, setPatients] = useState([]);
//   const [nextCursor, setNextCursor] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [billingLoading, setBillingLoading] = useState(false);
//   const [radiologists, setRadiologists] = useState([]);
//   const [institutions, setInstitutions] = useState([]);
//   const [modalities, setModalities] = useState([]);
//   const [api] = useState(() => new ApiHandlerSuperCoordinator());
//   const [billingData, setBillingData] = useState(null);
//   const [showBilling, setShowBilling] = useState(false);

//   // -------------------- Data Fetchers --------------------
//   const fetchInitialData = useCallback(async () => {
//     try {
//       const [radData, instData, modData] = await Promise.all([
//         api.getAllRadiologists(),
//         api.getAllInstitutions(),
//         api.getAllModalities()
//       ]);

//       setRadiologists(radData);
//       setInstitutions(instData);
//       setModalities(modData);
//     } catch (error) {
//       console.error('Error fetching initial data:', error);
//     }
//   }, [api]);

//   const fetchPatients = useCallback(async (filterParams = {}, cursor = null, append = false) => {
//     setLoading(true);
//     setBillingData(null);
//     setShowBilling(false);

//     try {
//       const query = new URLSearchParams();

//       if (filterParams.patientName) query.append("name", filterParams.patientName);
//       if (filterParams.startDate) query.append("start_date", filterParams.startDate);
//       if (filterParams.endDate) query.append("end_date", filterParams.endDate);
//       if (filterParams.receivedStartDate) query.append("received_start_date", filterParams.receivedStartDate);
//       if (filterParams.receivedEndDate) query.append("received_end_date", filterParams.receivedEndDate);

//       filterParams.modality.forEach(m => query.append("Modality", m));
//       filterParams.radiologist.forEach(r => query.append("radiologist", r));
//       filterParams.institution.forEach(i => query.append("institution", i));

//       if (filterParams.status && filterParams.status !== "All") {
//         query.append("status", filterParams.status);
//       }

//       if (cursor) query.append("cursor", cursor);

//       const data = await api.getPatients(query.toString());

//       if (append) {
//         setPatients(prev => [...prev, ...(data.results || [])]);
//       } else {
//         setPatients(data.results || []);
//       }

//       setNextCursor(data.next_cursor || null);
//     } catch (err) {
//       console.error("Error fetching patients:", err);
//     }

//     setLoading(false);
//   }, [api]);

//   useEffect(() => {
//     fetchInitialData();
//     fetchPatients();
//   }, [fetchInitialData, fetchPatients]);


//     // -------------------- Billing Calculator --------------------
 
//   const doctorBilling = async () => {
//      const enteredPin = prompt("Enter PIN to download Excel");

//   const PIN = "1234"; // 👉 change this

//   if (!enteredPin) return;

//   if (enteredPin !== PIN) {
//     alert("Wrong PIN ❌");
//     return;
//   }
//     if (!hasAtLeastOneFilter()) {
//       alert("Please apply at least one filter before calculating bill.");
//       return;
//     }

//     if (patients.length === 0) {
//       alert("No patients to calculate bill for.");
//       return;
//     }

//     setBillingLoading(true);
//     setBillingData(null);
//     setShowBilling(true);

//     try {
//       const patientsForBilling = patients.map((patient) => ({
//         Modality: patient.Modality,
//         radiologist_name: patient.radiologists.length > 0 ? patient.radiologists[0] : "Not assigned",
//         study_description: patient.study_description,
//         recived_on_db: patient.recived_on_db,
//         views: patient.imaging_views || 1,
//         PatientID: patient.patient_id || "N/A",
//         PatientName: patient.patient_name || "N/A"
//       }));

//       const response = await api.doctorBilling(patientsForBilling);
      
//       const transformedData = {
//         total_amount: 0,
//         patients_map: {},
//         success_count: response.total_success || 0,
//         failed_count: response.total_failed || 0,
//         total_received: response.total_received || 0
//       };
      
//       if (response.results && Array.isArray(response.results)) {
//         response.results.forEach(result => {
//           transformedData.patients_map[result.index] = {
//             price: result.price,
//             success: result.success,
//             error: result.error,
//             steps: result.steps,
//             night_charge_applied: result.steps?.some(step => 
//               step.includes("Night Charge Applicable: True")
//             ),
//             client_name: result.steps?.find(step => 
//               step.includes("Client Found:")
//             )?.split("Client Found:")[1]?.trim() || "N/A"
//           };
          
//           if (result.success) {
//             transformedData.total_amount += result.price;
//           }
//         });
//       }
      
//       setBillingData(transformedData);
      
//       if (response.total_failed > 0) {
//         alert(`Warning: ${response.total_failed} out of ${response.total_received} patients failed billing calculation. Please check the billing configuration for those patients.`);
//       }
      
//     } catch (error) {
//       console.error("Error calculating doctor billing:", error);
//       alert("Failed to calculate doctor billing. Please try again.");
//     } finally {
//       setBillingLoading(false);
//     }
//   };

//   const calculateBilling = async () => {
//      const enteredPin = prompt("Enter PIN to download Excel");

//   const PIN = "1234"; // 👉 change this

//   if (!enteredPin) return;

//   if (enteredPin !== PIN) {
//     alert("Wrong PIN ❌");
//     return;
//   }
//     if (!hasAtLeastOneFilter()) {
//       alert("Please apply at least one filter before calculating bill.");
//       return;
//     }

//     if (patients.length === 0) {
//       alert("No patients to calculate bill for.");
//       return;
//     }

//     setBillingLoading(true);
//     setBillingData(null);
//     setShowBilling(true);

//     try {
//       const patientsForBilling = patients.map((patient) => ({
//         Modality: patient.Modality,
//         Institution: patient.institution_name,
//         study_description: patient.study_description,
//         recived_on_db: patient.recived_on_db,
//         views: patient.imaging_views || 1,
//         PatientID: patient.patient_id || "N/A",
//         PatientName: patient.patient_name || "N/A"
//       }));

//       const response = await api.calculateBilling(patientsForBilling);
      
//       const transformedData = {
//         total_amount: 0,
//         patients_map: {},
//         success_count: response.total_success || 0,
//         failed_count: response.total_failed || 0,
//         total_received: response.total_received || 0
//       };
      
//       if (response.results && Array.isArray(response.results)) {
//         response.results.forEach(result => {
//           transformedData.patients_map[result.index] = {
//             price: result.price,
//             success: result.success,
//             error: result.error,
//             steps: result.steps,
//             night_charge_applied: result.steps?.some(step => 
//               step.includes("Night Charge Applicable: True")
//             ),
//             client_name: result.steps?.find(step => 
//               step.includes("Client Found:")
//             )?.split("Client Found:")[1]?.trim() || "N/A"
//           };
          
//           if (result.success) {
//             transformedData.total_amount += result.price;
//           }
//         });
//       }
      
//       setBillingData(transformedData);
      
//       if (response.total_failed > 0) {
//         alert(`Warning: ${response.total_failed} out of ${response.total_received} patients failed billing calculation. Please check the billing configuration for those patients.`);
//       }
      
//     } catch (error) {
//       console.error("Error calculating billing:", error);
//       alert("Failed to calculate billing. Please try again.");
//     } finally {
//       setBillingLoading(false);
//     }
//   };

//     const filteredPatients = patients.filter(patient => {
//     // Search by Patient ID (frontend only)
//     const matchesId = !frontendSearch.patientId || 
//       (patient.patient_id && patient.patient_id.toString().toLowerCase().includes(frontendSearch.patientId.toLowerCase()));
    
//     // Search by Patient Name (frontend only)
//     const matchesName = !frontendSearch.patientName || 
//       (patient.patient_name && patient.patient_name.toLowerCase().includes(frontendSearch.patientName.toLowerCase()));
    
//     return matchesId && matchesName;
//   });
//   // -------------------- Filter Handlers --------------------
//   const hasAtLeastOneFilter = () => {
//     return (
//       filters.patientName.trim() !== '' ||
//       filters.startDate !== '' ||
//       filters.endDate !== '' ||
//       filters.receivedStartDate !== '' ||
//       filters.receivedEndDate !== '' ||
//       filters.modality.length > 0 ||
//       filters.radiologist.length > 0 ||
//       filters.institution.length > 0 ||
//       (filters.status && filters.status !== 'All')
//     );
//   };

//   const handleApplyFilters = () => {
//     if (!hasAtLeastOneFilter()) {
//       alert("Please apply at least one filter before searching.");
//       return;
//     }
//     fetchPatients(filters);
//   };

//   const handleResetFilters = () => {
//     const resetFilters = {
//       patientName: '',
//       startDate: '',
//       endDate: '',
//       receivedStartDate: '',
//       receivedEndDate: '',
//       modality: [],
//       radiologist: [],
//       status: 'All',
//       institution: []
//     };
//     setFilters(resetFilters);
//     setBillingData(null);
//     setShowBilling(false);
//     fetchPatients();
//   };

//   const handleLoadMore = () => {
//     if (nextCursor) fetchPatients(filters, nextCursor, true);
//   };

//   // const handleExportExcel = async () => {
//   //   if (!hasAtLeastOneFilter()) {
//   //     alert("Please apply at least one filter before exporting.");
//   //     return;
//   //   }

//   //   const query = new URLSearchParams();

//   //   if (filters.patientName) query.append("name", filters.patientName);
//   //   if (filters.startDate) query.append("start_date", filters.startDate);
//   //   if (filters.endDate) query.append("end_date", filters.endDate);
//   //   if (filters.receivedStartDate) query.append("received_start_date", filters.receivedStartDate);
//   //   if (filters.receivedEndDate) query.append("received_end_date", filters.receivedEndDate);

//   //   filters.modality.forEach(m => query.append("Modality", m));
//   //   filters.radiologist.forEach(r => query.append("radiologist", r));
//   //   filters.institution.forEach(i => query.append("institution", i));
//   //   if (filters.status && filters.status !== "All") query.append("status", filters.status);

//   //   query.append("export", "1");

//   //   api.exportPatients(query.toString());
//   // };

//   const handleExportExcel = async () => {
//     if (!hasAtLeastOneFilter()) {
//       alert("Please apply at least one filter before exporting.");
//       return;
//     }
  
//     try {
//       // Build query parameters
//       const query = new URLSearchParams();
  
//       if (filters.patientName) query.append("name", filters.patientName);
//       if (filters.startDate) query.append("start_date", filters.startDate);
//       if (filters.endDate) query.append("end_date", filters.endDate);
//       if (filters.receivedStartDate) query.append("received_start_date", filters.receivedStartDate);
//       if (filters.receivedEndDate) query.append("received_end_date", filters.receivedEndDate);
  
//       filters.modality.forEach(m => query.append("Modality", m));
//       filters.radiologist.forEach(r => query.append("radiologist", r));
//       filters.institution.forEach(i => query.append("institution", i));
      
//       if (filters.status && filters.status !== "All") {
//         query.append("status", filters.status);
//       }
  
//       // Add export flag
//       query.append("export", "1");
  
//       // Call export endpoint with query string
//       await api.exportPatients(query.toString());
      
//     } catch (error) {
//       console.error("Error exporting to Excel:", error);
//       alert("Failed to export data. Please try again.");
//     }
//   };



// const handleExportBillingExcel = async () => {
//   const enteredPassword = window.prompt(
//     "Enter password to download Billing Excel:"
//   );

//   if (!enteredPassword) return;

//   if (enteredPassword !== "U4rad1098") {
//     alert("Incorrect password");
//     return;
//   }

//   if (!hasAtLeastOneFilter()) {
//     alert("Please apply at least one filter before exporting.");
//     return;
//   }

//   try {
//     const query = new URLSearchParams();

//     if (filters.patientName) query.append("name", filters.patientName);
//     if (filters.startDate) query.append("start_date", filters.startDate);
//     if (filters.endDate) query.append("end_date", filters.endDate);
//     if (filters.receivedStartDate)
//       query.append("received_start_date", filters.receivedStartDate);
//     if (filters.receivedEndDate)
//       query.append("received_end_date", filters.receivedEndDate);

//     filters.modality.forEach((m) => query.append("Modality", m));
//     filters.radiologist.forEach((r) => query.append("radiologist", r));
//     filters.institution.forEach((i) => query.append("institution", i));

//     if (filters.status && filters.status !== "All") {
//       query.append("status", filters.status);
//     }

//     query.append("export", "2");

//     await api.exportPatients(query.toString());

//   } catch (error) {
//     console.error("Error exporting billing Excel:", error);
//     alert("Failed to export billing data.");
//   }
// };

// const handleExportDoctorBillingExcel = async () => {
//   const enteredPassword = window.prompt(
//     "Enter password to download Doctor Billing Excel:"
//   );

//   if (!enteredPassword) return;

//   if (enteredPassword !== "U4rad1098") {
//     alert("Incorrect password");
//     return;
//   }

//   if (!hasAtLeastOneFilter()) {
//     alert("Please apply at least one filter before exporting.");
//     return;
//   }

//   try {
//     const query = new URLSearchParams();

//     if (filters.patientName)
//       query.append("name", filters.patientName);

//     if (filters.startDate)
//       query.append("start_date", filters.startDate);

//     if (filters.endDate)
//       query.append("end_date", filters.endDate);

//     if (filters.receivedStartDate) {
//       query.append(
//         "received_start_date",
//         filters.receivedStartDate
//       );
//     }

//     if (filters.receivedEndDate) {
//       query.append(
//         "received_end_date",
//         filters.receivedEndDate
//       );
//     }

//     filters.modality.forEach((m) =>
//       query.append("Modality", m)
//     );

//     filters.radiologist.forEach((r) =>
//       query.append("radiologist", r)
//     );

//     filters.institution.forEach((i) =>
//       query.append("institution", i)
//     );

//     if (
//       filters.status &&
//       filters.status !== "All"
//     ) {
//       query.append("status", filters.status);
//     }

//     query.append("export", "3");

//     await api.exportPatients(query.toString());

//   } catch (error) {
//     console.error(
//       "Error exporting doctor billing Excel:",
//       error
//     );

//     alert("Failed to export doctor billing data.");
//   }
// };
// //  const handleExportExcelfrontend = () => {
// //   const enteredPin = prompt("Enter PIN to download Excel");

// //   const PIN = "1234"; // 👉 change this

// //   if (!enteredPin) return;

// //   if (enteredPin !== PIN) {
// //     alert("Wrong PIN ❌");
// //     return;
// //   }

// //   // ✅ Existing logic starts here
// //   if (!hasAtLeastOneFilter()) {
// //     alert("Please apply at least one filter before exporting.");
// //     return;
// //   }

// //   if (patients.length === 0) {
// //     alert("No patient records available to export.");
// //     return;
// //   }

// //   try {
// //     const excelData = filteredPatients.map((patient, index) => {
// //       const patientIndex = patients.findIndex(p => p.id === patient.id);
// //       const patientBill = billingData?.patients_map?.[patientIndex];

// //       return {
// //         "S.No": index + 1,
// //         "Patient Name": patient.patient_name || "N/A",
// //         "Patient ID": patient.patient_id || "N/A",
// //         "Age": patient.age || "N/A",
// //         "Gender": patient.gender || "N/A",
// //         "Age/Gender": `${patient.age || "N/A"} / ${patient.gender || "N/A"}`,
// //         "Study Date": patient.study_date || "N/A",
// //         "Received On": formatDate(patient.recived_on_db),
// //         "Modality": patient.Modality || "N/A",
// //         "Institution": patient.institution_name || "N/A",
// //         "Study Description": patient.study_description || "N/A",
// //         "Body Part": patient.body_part_examined || "N/A",
// //         "Views": patient.imaging_views || "N/A",
// //         "Status": patient.isDone ? "Reported" : "Pending",
// //         "Urgent": patient.urgent ? "Yes" : "No",
// //         "Radiologists": patient.radiologists?.length > 0
// //           ? patient.radiologists.join(", ")
// //           : "Not assigned",
// //         "Bill Amount": patientBill && patientBill.success 
// //           ? formatCurrency(patientBill.price) 
// //           : "N/A",
// //         "Night Charge Applied": patientBill?.night_charge_applied ? "Yes" : "No",
// //         "Client Name": patientBill?.client_name || "N/A"
// //       };
// //     });

// //     if (billingData && billingData.total_amount) {
// //       excelData.push({});
// //       excelData.push({
// //         "Patient Name": "TOTAL BILL AMOUNT",
// //         "Bill Amount": formatCurrency(billingData.total_amount)
// //       });
// //     }

// //     const worksheet = XLSX.utils.json_to_sheet(excelData);

// //     worksheet["!cols"] = [
// //       { wch: 8 }, { wch: 20 }, { wch: 15 }, { wch: 8 }, { wch: 10 },
// //       { wch: 15 }, { wch: 15 }, { wch: 22 }, { wch: 12 }, { wch: 25 },
// //       { wch: 30 }, { wch: 20 }, { wch: 10 }, { wch: 12 }, { wch: 10 },
// //       { wch: 30 }, { wch: 15 }, { wch: 20 }, { wch: 20 },
// //     ];

// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Patient Records");

// //     const excelBuffer = XLSX.write(workbook, {
// //       bookType: "xlsx",
// //       type: "array"
// //     });

// //     const fileData = new Blob([excelBuffer], {
// //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
// //     });

// //     saveAs(fileData, `patient_records_${new Date().toISOString().slice(0, 10)}.xlsx`);

// //   } catch (error) {
// //     console.error("Error exporting Excel:", error);
// //     alert("Failed to export Excel.");
// //   }
// // };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

// const formatCurrency = (amount) => {
//   return new Intl.NumberFormat('en-IN', {
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 2
//   }).format(amount);
// };

//   // -------------------- JSX --------------------
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
//       <div className="w-full h-full">
//         {/* Filters Section */}
//         <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
//           <h1 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
//             <Search className="text-blue-600" size={32} />
//             Search Patient Records
//           </h1>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
//             {/* Filter Inputs */}
//             {/* Patient Name */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Patient Name:
//               </label>
//               <input
//                 type="text"
//                 placeholder="Enter patient name"
//                 value={filters.patientName}
//                 onChange={(e) => setFilters({...filters, patientName: e.target.value})}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             {/* Start Date */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Start Date:
//               </label>
//               <input
//                 type="date"
//                 value={filters.startDate}
//                 onChange={(e) => setFilters({...filters, startDate: e.target.value})}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             {/* End Date */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 End Date:
//               </label>
//               <input
//                 type="date"
//                 value={filters.endDate}
//                 onChange={(e) => setFilters({...filters, endDate: e.target.value})}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             {/* Received Start Date */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Received Start Date:
//               </label>
//               <input
//                 type="date"
//                 value={filters.receivedStartDate}
//                 onChange={(e) => setFilters({...filters, receivedStartDate: e.target.value})}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             {/* Received End Date */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Received End Date:
//               </label>
//               <input
//                 type="date"
//                 value={filters.receivedEndDate}
//                 onChange={(e) => setFilters({...filters, receivedEndDate: e.target.value})}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//             </div>
//             {/* Modality */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Modality:
//               </label>
            
//               <input
//                 type="text"
//                 placeholder="Search modality..."
//                 value={searchTerms.modality}
//                 onChange={(e) =>
//                   setSearchTerms({ ...searchTerms, modality: e.target.value })
//                 }
//                 className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-lg"
//               />
            
//               <select
//                 multiple
//                 value={filters.modality}
//                 onChange={(e) => {
//                   const selected = Array.from(
//                     e.target.selectedOptions,
//                     option => option.value
//                   );
//                   setFilters({ ...filters, modality: selected });
//                 }}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                 size="4"
//               >
//                 {[...modalities]
//                   .filter(mod =>
//                     mod.toLowerCase().includes(searchTerms.modality.toLowerCase())
//                   )
//                   .sort((a, b) => a.localeCompare(b))
//                   .map(mod => (
//                     <option key={mod} value={mod}>
//                       {mod}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             {/* Radiologist */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Radiologist:
//               </label>
            
//               {/* search box */}
//               <input
//                 type="text"
//                 placeholder="Search radiologist..."
//                 value={searchTerms.radiologist}
//                 onChange={(e) =>
//                   setSearchTerms({ ...searchTerms, radiologist: e.target.value })
//                 }
//                 className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-lg"
//               />
            
//               {/* dropdown */}
//               <select
//                 multiple
//                 value={filters.radiologist}
//                 onChange={(e) => {
//                   const selected = Array.from(
//                     e.target.selectedOptions,
//                     option => option.value
//                   );
//                   setFilters({ ...filters, radiologist: selected });
//                 }}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                 size="4"
//               >
//                 {[...radiologists]
//                   .filter(rad =>
//                     `${rad.name} ${rad.email}`
//                       .toLowerCase()
//                       .includes(searchTerms.radiologist.toLowerCase())
//                   )
//                   .sort((a, b) => a.name.localeCompare(b.name))
//                   .map(rad => (
//                     <option key={rad.id} value={rad.id}>
//                       {rad.name} ({rad.email})
//                     </option>
//                   ))}
//               </select>
            
//               <p className="text-xs text-gray-500 mt-1">
//                 Hold Ctrl/Cmd to select multiple
//               </p>
//             </div>
//             {/* Status */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Status:
//               </label>
//               <select
//                 value={filters.status}
//                 onChange={(e) => setFilters({...filters, status: e.target.value})}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               >
//                 <option value="All">All</option>
//                 <option value="Reported">Reported</option>
//                 <option value="Pending">Pending</option>
//               </select>
//             </div>
//             {/* Institution */}
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Institution Name:
//               </label>
            
//               <input
//                 type="text"
//                 placeholder="Search institution..."
//                 value={searchTerms.institution}
//                 onChange={(e) =>
//                   setSearchTerms({ ...searchTerms, institution: e.target.value })
//                 }
//                 className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-lg"
//               />
            
//               <select
//                 multiple
//                 value={filters.institution}
//                 onChange={(e) => {
//                   const selected = Array.from(
//                     e.target.selectedOptions,
//                     option => option.value
//                   );
//                   setFilters({ ...filters, institution: selected });
//                 }}
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg"
//                 size="4"
//               >
//                 {[...institutions]
//                   .filter(inst =>
//                     inst.name
//                       .toLowerCase()
//                       .includes(searchTerms.institution.toLowerCase())
//                   )
//                   .sort((a, b) => a.name.localeCompare(b.name))
//                   .map(inst => (
//                     <option key={inst.name} value={inst.name}>
//                       {inst.name}
//                     </option>
//                   ))}
//               </select>
//             </div>

//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap gap-4">
//             <button
//               disabled={!hasAtLeastOneFilter()}
//               onClick={handleApplyFilters}
//               className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors
//                 ${hasAtLeastOneFilter() ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
//             >
//               <Filter size={20} /> Apply Filters
//             </button>
//    <button
//               onClick={calculateBilling}
//               disabled={billingLoading || patients.length === 0}
//               className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors
//                 ${billingLoading || patients.length === 0 
//                   ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
//                   : 'bg-purple-600 hover:bg-purple-700 text-white'}`}
//             >
//               {billingLoading ? 'Calculating...' : 'Calculate Bill'}
//             </button>
//             <button
//               onClick={doctorBilling}
//               disabled={billingLoading || patients.length === 0}
//               className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors
//                 ${billingLoading || patients.length === 0 
//                   ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
//                   : 'bg-purple-600 hover:bg-purple-700 text-white'}`}
//             >
//               {billingLoading ? 'Calculating...' : 'Calculate doctor Bill'}
//             </button>
           
//             <button
//               onClick={handleExportExcel}
//               className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
//             >
//               <Download size={20} /> Get Excel
//             </button>
//             <button
//   onClick={handleExportBillingExcel}
//   className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
// >
//   <Download size={20} />
//   Get client Billing Excel
// </button>
//            <button
//   onClick={handleExportDoctorBillingExcel}
//   className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
// >
//   <Download size={20} />
//   Get doctor Billing Excel
// </button>
//             <button
//               onClick={handleResetFilters}
//               className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
//             >
//               <RotateCcw size={20} /> Reset Filters
//             </button>
//             {/* <button
//   onClick={handleExportExcelfrontend}
//   className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
// >
//   <Download size={20} /> Get Billing Excel
// </button> */}
//           </div>
//         </div>
        

//             {/* Table Section */}
//         <div className="bg-white rounded-lg shadow-lg p-6">
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-2xl font-bold text-gray-800">
//               Patient Records ({patients.length})
//             </h2>
//                {billingData && showBilling && (
//               <div className="bg-purple-100 text-purple-800 px-6 py-3 rounded-lg font-semibold">
//                 Total Bill Amount: {formatCurrency(billingData.total_amount)}
//                 {billingData.failed_count > 0 && (
//                   <span className="ml-2 text-sm text-red-600">
//                     ({billingData.failed_count} failed)
//                   </span>
//                 )}
//               </div>
//             )}
        
//           </div>
//     {loading ? (
//             <div className="text-center py-12">
//               <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//               <p className="mt-4 text-gray-600">Loading patient records...</p>
//             </div>
//           ) : filteredPatients.length === 0 ? (
//             <div className="text-center py-12 text-gray-500">
//               <Search size={48} className="mx-auto mb-4 opacity-50" />
//               <p className="text-lg">No patient records found</p>
//               <p className="text-sm">Try adjusting your search filters</p>
//             </div>
//           ): (
//           <div className="overflow-x-auto">
//   <table className="w-full border-collapse">
//     <thead>
//       <tr className="bg-gray-100 border-b-2 border-gray-300">
      
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Patient Name</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Patient ID</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Age/Gender</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Study Date</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Received On</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Modality</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Institution</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Study Description</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Body Part</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Views</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Status</th>
//         <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Radiologists</th>
//         {/* New Billing Column - Only show when billing data is available */}
//          {billingData && showBilling && (
//                       <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 bg-purple-50">
//                         Bill Amount
//                       </th>
//                     )}
//       </tr>
//     </thead>
    

//    <tbody>
//                   {filteredPatients.map(patient => {
//                     const patientIndex = patients.findIndex(p => p.id === patient.id);
//                     const patientBill = billingData?.patients_map?.[patientIndex];
                    
//                     return (
//                       <tr key={patient.id} className="border-b hover:bg-gray-50 transition-colors">
//                         <td className="px-4 py-3 text-sm">{patient.patient_name}</td>
//                         <td className="px-4 py-3 text-sm font-mono">{patient.patient_id}</td>
//                         <td className="px-4 py-3 text-sm">{patient.age} / {patient.gender}</td>
//                         <td className="px-4 py-3 text-sm">{patient.study_date || 'N/A'}</td>
//                         <td className="px-4 py-3 text-sm">{formatDate(patient.recived_on_db)}</td>
//                         <td className="px-4 py-3 text-sm">
//                           <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
//                             {patient.Modality || 'N/A'}
//                           </span>
//                         </td>
//                         <td className="px-4 py-3 text-sm">{patient.institution_name}</td>
//                         <td className="px-4 py-3 text-sm">
//                           {patient.study_description || 'N/A'}
//                         </td>
//                         <td className="px-4 py-3 text-sm">
//                           {patient.body_part_examined || 'N/A'}
//                         </td>
//                         <td className="px-4 py-3 text-sm">
//                           {patient.imaging_views || 'N/A'}
//                         </td>
//                         <td className="px-4 py-3 text-sm">
//                           <span
//                             className={`px-2 py-1 rounded text-xs font-medium ${
//                               patient.isDone
//                                 ? 'bg-green-100 text-green-800'
//                                 : 'bg-yellow-100 text-yellow-800'
//                             }`}
//                           >
//                             {patient.isDone ? 'Reported' : 'Pending'}
//                           </span>
//                           {patient.urgent && (
//                             <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 rounded text-xs font-medium">
//                               Urgent
//                             </span>
//                           )}
//                         </td>
//                         <td className="px-4 py-3 text-sm">
//                           {patient.radiologists.length > 0
//                             ? patient.radiologists.join(', ')
//                             : 'Not assigned'}
//                         </td>
//                         {billingData && showBilling && (
//                           <td className="px-4 py-3 text-sm bg-purple-50">
//                             {(() => {
//                               if (!patientBill) {
//                                 return <span className="text-gray-400">N/A</span>;
//                               }
                              
//                               if (patientBill.success) {
//                                 return (
//                                   <div>
//                                     <span className="font-semibold text-purple-700">
//                                       {formatCurrency(patientBill.price)}
//                                     </span>
//                                     {patientBill.night_charge_applied && (
//                                       <span className="ml-2 text-xs bg-purple-200 text-purple-800 px-2 py-1 rounded">
//                                         Night Charge
//                                       </span>
//                                     )}
//                                     <div className="text-xs text-gray-500 mt-1">
//                                       Client: {patientBill.client_name}
//                                     </div>
//                                   </div>
//                                 );
//                               } else {
//                                 return (
//                                   <div>
//                                     <span className="text-red-500 text-xs">Failed: {patientBill.error}</span>
//                                   </div>
//                                 );
//                               }
//                             })()}
//                           </td>
//                         )}
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//   </table>

//   {nextCursor && (
//     <div className="text-center mt-6">
//       <button
//         onClick={handleLoadMore}
//         className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold transition-colors"
//       >
//         Load More
//       </button>
//     </div>
//   )}
// </div>
//           )}
//         </div>
     
//       </div>
//     </div>
//   );
// }
         


import React, { useState, useEffect, useCallback } from 'react';
import { Search, Download, RotateCcw, Filter } from 'lucide-react';
import ApiHandlerSuperCoordinator from './apiHandlerSuperCoordinator';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default function PatientRecordsSearch() {
  const [filters, setFilters] = useState({
    patientName: '',
    startDate: '',
    endDate: '',
    receivedStartDate: '',
    receivedEndDate: '',
    modality: [],
    radiologist: [],
    status: 'All',
    institution: []
  });

  const [searchTerms, setSearchTerms] = useState({
    radiologist: "",
    institution: "",
    modality: ""
  });

    const [frontendSearch, setFrontendSearch] = useState({
    patientId: '',
    patientName: ''
  });
  const [patients, setPatients] = useState([]);
  const [nextCursor, setNextCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [billingLoading, setBillingLoading] = useState(false);
  const [radiologists, setRadiologists] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [modalities, setModalities] = useState([]);
  const [api] = useState(() => new ApiHandlerSuperCoordinator());
  const [billingData, setBillingData] = useState(null);
  const [showBilling, setShowBilling] = useState(false);

  // -------------------- Data Fetchers --------------------
  const fetchInitialData = useCallback(async () => {
    try {
      const [radData, instData, modData] = await Promise.all([
        api.getAllRadiologists(),
        api.getAllInstitutions(),
        api.getAllModalities()
      ]);

      setRadiologists(radData);
      setInstitutions(instData);
      setModalities(modData);
    } catch (error) {
      console.error('Error fetching initial data:', error);
    }
  }, [api]);

  const fetchPatients = useCallback(async (filterParams = {}, cursor = null, append = false) => {
    setLoading(true);
    setBillingData(null);
    setShowBilling(false);

    try {
      const query = new URLSearchParams();

      if (filterParams.patientName) query.append("name", filterParams.patientName);
      if (filterParams.startDate) query.append("start_date", filterParams.startDate);
      if (filterParams.endDate) query.append("end_date", filterParams.endDate);
      if (filterParams.receivedStartDate) query.append("received_start_date", filterParams.receivedStartDate);
      if (filterParams.receivedEndDate) query.append("received_end_date", filterParams.receivedEndDate);

      (filterParams.modality || []).forEach(m => query.append("Modality", m));
      (filterParams.radiologist || []).forEach(r => query.append("radiologist", r));
      (filterParams.institution || []).forEach(i => query.append("institution", i));

      if (filterParams.status && filterParams.status !== "All") {
        query.append("status", filterParams.status);
      }

      if (cursor) query.append("cursor", cursor);

      const data = await api.getPatients(query.toString());

      if (append) {
        setPatients(prev => [...prev, ...(data.results || [])]);
      } else {
        setPatients(data.results || []);
      }

      setNextCursor(data.next_cursor || null);
    } catch (err) {
      console.error("Error fetching patients:", err);
    }

    setLoading(false);
  }, [api]);

  useEffect(() => {
    fetchInitialData();
    fetchPatients();
  }, [fetchInitialData, fetchPatients]);


    // -------------------- Billing Calculator --------------------
 
  const doctorBilling = async () => {
     const enteredPin = prompt("Enter PIN to download Excel");

  const PIN = "1234"; // 👉 change this

  if (!enteredPin) return;

  if (enteredPin !== PIN) {
    alert("Wrong PIN ❌");
    return;
  }
    if (!hasAtLeastOneFilter()) {
      alert("Please apply at least one filter before calculating bill.");
      return;
    }

    if (patients.length === 0) {
      alert("No patients to calculate bill for.");
      return;
    }

    setBillingLoading(true);
    setBillingData(null);
    setShowBilling(true);

    try {
      const patientsForBilling = patients.map((patient) => ({
        Modality: patient.Modality,
        radiologist_name: patient.radiologists.length > 0 ? patient.radiologists[0] : "Not assigned",
        study_description: patient.study_description,
        recived_on_db: patient.recived_on_db,
        views: patient.imaging_views || 1,
        PatientID: patient.patient_id || "N/A",
        PatientName: patient.patient_name || "N/A"
      }));

      const response = await api.doctorBilling(patientsForBilling);
      
      const transformedData = {
        total_amount: 0,
        patients_map: {},
        success_count: response.total_success || 0,
        failed_count: response.total_failed || 0,
        total_received: response.total_received || 0
      };
      
      if (response.results && Array.isArray(response.results)) {
        response.results.forEach(result => {
          transformedData.patients_map[result.index] = {
            price: result.price,
            success: result.success,
            error: result.error,
            steps: result.steps,
            night_charge_applied: result.steps?.some(step => 
              step.includes("Night Charge Applicable: True")
            ),
            client_name: result.steps?.find(step => 
              step.includes("Client Found:")
            )?.split("Client Found:")[1]?.trim() || "N/A"
          };
          
          if (result.success) {
            transformedData.total_amount += result.price;
          }
        });
      }
      
      setBillingData(transformedData);
      
      if (response.total_failed > 0) {
        alert(`Warning: ${response.total_failed} out of ${response.total_received} patients failed billing calculation. Please check the billing configuration for those patients.`);
      }
      
    } catch (error) {
      console.error("Error calculating doctor billing:", error);
      alert("Failed to calculate doctor billing. Please try again.");
    } finally {
      setBillingLoading(false);
    }
  };

  const calculateBilling = async () => {
     const enteredPin = prompt("Enter PIN to download Excel");

  const PIN = "1234"; // 👉 change this

  if (!enteredPin) return;

  if (enteredPin !== PIN) {
    alert("Wrong PIN ❌");
    return;
  }
    if (!hasAtLeastOneFilter()) {
      alert("Please apply at least one filter before calculating bill.");
      return;
    }

    if (patients.length === 0) {
      alert("No patients to calculate bill for.");
      return;
    }

    setBillingLoading(true);
    setBillingData(null);
    setShowBilling(true);

    try {
      const patientsForBilling = patients.map((patient) => ({
        Modality: patient.Modality,
        Institution: patient.institution_name,
        study_description: patient.study_description,
        recived_on_db: patient.recived_on_db,
        views: patient.imaging_views || 1,
        PatientID: patient.patient_id || "N/A",
        PatientName: patient.patient_name || "N/A"
      }));

      const response = await api.calculateBilling(patientsForBilling);
      
      const transformedData = {
        total_amount: 0,
        patients_map: {},
        success_count: response.total_success || 0,
        failed_count: response.total_failed || 0,
        total_received: response.total_received || 0
      };
      
      if (response.results && Array.isArray(response.results)) {
        response.results.forEach(result => {
          transformedData.patients_map[result.index] = {
            price: result.price,
            success: result.success,
            error: result.error,
            steps: result.steps,
            night_charge_applied: result.steps?.some(step => 
              step.includes("Night Charge Applicable: True")
            ),
            client_name: result.steps?.find(step => 
              step.includes("Client Found:")
            )?.split("Client Found:")[1]?.trim() || "N/A"
          };
          
          if (result.success) {
            transformedData.total_amount += result.price;
          }
        });
      }
      
      setBillingData(transformedData);
      
      if (response.total_failed > 0) {
        alert(`Warning: ${response.total_failed} out of ${response.total_received} patients failed billing calculation. Please check the billing configuration for those patients.`);
      }
      
    } catch (error) {
      console.error("Error calculating billing:", error);
      alert("Failed to calculate billing. Please try again.");
    } finally {
      setBillingLoading(false);
    }
  };

    const filteredPatients = patients.filter(patient => {
    // Search by Patient ID (frontend only)
    const matchesId = !frontendSearch.patientId || 
      (patient.patient_id && patient.patient_id.toString().toLowerCase().includes(frontendSearch.patientId.toLowerCase()));
    
    // Search by Patient Name (frontend only)
    const matchesName = !frontendSearch.patientName || 
      (patient.patient_name && patient.patient_name.toLowerCase().includes(frontendSearch.patientName.toLowerCase()));
    
    return matchesId && matchesName;
  });
  // -------------------- Filter Handlers --------------------
  const hasAtLeastOneFilter = () => {
    return (
      filters.patientName.trim() !== '' ||
      filters.startDate !== '' ||
      filters.endDate !== '' ||
      filters.receivedStartDate !== '' ||
      filters.receivedEndDate !== '' ||
      filters.modality.length > 0 ||
      filters.radiologist.length > 0 ||
      filters.institution.length > 0 ||
      (filters.status && filters.status !== 'All')
    );
  };

  const handleApplyFilters = () => {
    if (!hasAtLeastOneFilter()) {
      alert("Please apply at least one filter before searching.");
      return;
    }
    fetchPatients(filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      patientName: '',
      startDate: '',
      endDate: '',
      receivedStartDate: '',
      receivedEndDate: '',
      modality: [],
      radiologist: [],
      status: 'All',
      institution: []
    };
    setFilters(resetFilters);
    setBillingData(null);
    setShowBilling(false);
    fetchPatients();
  };

  const handleLoadMore = () => {
    if (nextCursor) fetchPatients(filters, nextCursor, true);
  };

  // const handleExportExcel = async () => {
  //   if (!hasAtLeastOneFilter()) {
  //     alert("Please apply at least one filter before exporting.");
  //     return;
  //   }

  //   const query = new URLSearchParams();

  //   if (filters.patientName) query.append("name", filters.patientName);
  //   if (filters.startDate) query.append("start_date", filters.startDate);
  //   if (filters.endDate) query.append("end_date", filters.endDate);
  //   if (filters.receivedStartDate) query.append("received_start_date", filters.receivedStartDate);
  //   if (filters.receivedEndDate) query.append("received_end_date", filters.receivedEndDate);

  //   filters.modality.forEach(m => query.append("Modality", m));
  //   filters.radiologist.forEach(r => query.append("radiologist", r));
  //   filters.institution.forEach(i => query.append("institution", i));
  //   if (filters.status && filters.status !== "All") query.append("status", filters.status);

  //   query.append("export", "1");

  //   api.exportPatients(query.toString());
  // };

  const handleExportExcel = async () => {
    if (!hasAtLeastOneFilter()) {
      alert("Please apply at least one filter before exporting.");
      return;
    }
  
    try {
      // Build query parameters
      const query = new URLSearchParams();
  
      if (filters.patientName) query.append("name", filters.patientName);
      if (filters.startDate) query.append("start_date", filters.startDate);
      if (filters.endDate) query.append("end_date", filters.endDate);
      if (filters.receivedStartDate) query.append("received_start_date", filters.receivedStartDate);
      if (filters.receivedEndDate) query.append("received_end_date", filters.receivedEndDate);
  
      filters.modality.forEach(m => query.append("Modality", m));
      filters.radiologist.forEach(r => query.append("radiologist", r));
      filters.institution.forEach(i => query.append("institution", i));
      
      if (filters.status && filters.status !== "All") {
        query.append("status", filters.status);
      }
  
      // Add export flag
      query.append("export", "1");
  
      // Call export endpoint with query string
      await api.exportPatients(query.toString());
      
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Failed to export data. Please try again.");
    }
  };



const handleExportBillingExcel = async () => {
  const enteredPassword = window.prompt(
    "Enter password to download Billing Excel:"
  );

  if (!enteredPassword) return;

  if (enteredPassword !== "U4rad1098") {
    alert("Incorrect password");
    return;
  }

  if (!hasAtLeastOneFilter()) {
    alert("Please apply at least one filter before exporting.");
    return;
  }

  try {
    const query = new URLSearchParams();

    if (filters.patientName) query.append("name", filters.patientName);
    if (filters.startDate) query.append("start_date", filters.startDate);
    if (filters.endDate) query.append("end_date", filters.endDate);
    if (filters.receivedStartDate)
      query.append("received_start_date", filters.receivedStartDate);
    if (filters.receivedEndDate)
      query.append("received_end_date", filters.receivedEndDate);

    filters.modality.forEach((m) => query.append("Modality", m));
    filters.radiologist.forEach((r) => query.append("radiologist", r));
    filters.institution.forEach((i) => query.append("institution", i));

    if (filters.status && filters.status !== "All") {
      query.append("status", filters.status);
    }

    query.append("export", "2");

    await api.exportPatients(query.toString());

  } catch (error) {
    console.error("Error exporting billing Excel:", error);
    alert("Failed to export billing data.");
  }
};

const handleExportDoctorBillingExcel = async () => {
  const enteredPassword = window.prompt(
    "Enter password to download Doctor Billing Excel:"
  );

  if (!enteredPassword) return;

  if (enteredPassword !== "U4rad1098") {
    alert("Incorrect password");
    return;
  }

  if (!hasAtLeastOneFilter()) {
    alert("Please apply at least one filter before exporting.");
    return;
  }

  try {
    const query = new URLSearchParams();

    if (filters.patientName)
      query.append("name", filters.patientName);

    if (filters.startDate)
      query.append("start_date", filters.startDate);

    if (filters.endDate)
      query.append("end_date", filters.endDate);

    if (filters.receivedStartDate) {
      query.append(
        "received_start_date",
        filters.receivedStartDate
      );
    }

    if (filters.receivedEndDate) {
      query.append(
        "received_end_date",
        filters.receivedEndDate
      );
    }

    filters.modality.forEach((m) =>
      query.append("Modality", m)
    );

    filters.radiologist.forEach((r) =>
      query.append("radiologist", r)
    );

    filters.institution.forEach((i) =>
      query.append("institution", i)
    );

    if (
      filters.status &&
      filters.status !== "All"
    ) {
      query.append("status", filters.status);
    }

    query.append("export", "3");

    await api.exportPatients(query.toString());

  } catch (error) {
    console.error(
      "Error exporting doctor billing Excel:",
      error
    );

    alert("Failed to export doctor billing data.");
  }
};
//  const handleExportExcelfrontend = () => {
//   const enteredPin = prompt("Enter PIN to download Excel");

//   const PIN = "1234"; // 👉 change this

//   if (!enteredPin) return;

//   if (enteredPin !== PIN) {
//     alert("Wrong PIN ❌");
//     return;
//   }

//   // ✅ Existing logic starts here
//   if (!hasAtLeastOneFilter()) {
//     alert("Please apply at least one filter before exporting.");
//     return;
//   }

//   if (patients.length === 0) {
//     alert("No patient records available to export.");
//     return;
//   }

//   try {
//     const excelData = filteredPatients.map((patient, index) => {
//       const patientIndex = patients.findIndex(p => p.id === patient.id);
//       const patientBill = billingData?.patients_map?.[patientIndex];

//       return {
//         "S.No": index + 1,
//         "Patient Name": patient.patient_name || "N/A",
//         "Patient ID": patient.patient_id || "N/A",
//         "Age": patient.age || "N/A",
//         "Gender": patient.gender || "N/A",
//         "Age/Gender": `${patient.age || "N/A"} / ${patient.gender || "N/A"}`,
//         "Study Date": patient.study_date || "N/A",
//         "Received On": formatDate(patient.recived_on_db),
//         "Modality": patient.Modality || "N/A",
//         "Institution": patient.institution_name || "N/A",
//         "Study Description": patient.study_description || "N/A",
//         "Body Part": patient.body_part_examined || "N/A",
//         "Views": patient.imaging_views || "N/A",
//         "Status": patient.isDone ? "Reported" : "Pending",
//         "Urgent": patient.urgent ? "Yes" : "No",
//         "Radiologists": patient.radiologists?.length > 0
//           ? patient.radiologists.join(", ")
//           : "Not assigned",
//         "Bill Amount": patientBill && patientBill.success 
//           ? formatCurrency(patientBill.price) 
//           : "N/A",
//         "Night Charge Applied": patientBill?.night_charge_applied ? "Yes" : "No",
//         "Client Name": patientBill?.client_name || "N/A"
//       };
//     });

//     if (billingData && billingData.total_amount) {
//       excelData.push({});
//       excelData.push({
//         "Patient Name": "TOTAL BILL AMOUNT",
//         "Bill Amount": formatCurrency(billingData.total_amount)
//       });
//     }

//     const worksheet = XLSX.utils.json_to_sheet(excelData);

//     worksheet["!cols"] = [
//       { wch: 8 }, { wch: 20 }, { wch: 15 }, { wch: 8 }, { wch: 10 },
//       { wch: 15 }, { wch: 15 }, { wch: 22 }, { wch: 12 }, { wch: 25 },
//       { wch: 30 }, { wch: 20 }, { wch: 10 }, { wch: 12 }, { wch: 10 },
//       { wch: 30 }, { wch: 15 }, { wch: 20 }, { wch: 20 },
//     ];

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Patient Records");

//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array"
//     });

//     const fileData = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//     });

//     saveAs(fileData, `patient_records_${new Date().toISOString().slice(0, 10)}.xlsx`);

//   } catch (error) {
//     console.error("Error exporting Excel:", error);
//     alert("Failed to export Excel.");
//   }
// };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
};

  // -------------------- JSX --------------------
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="w-full h-full">
        {/* Filters Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <Search className="text-blue-600" size={32} />
            Search Patient Records
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            {/* Filter Inputs */}
            {/* Patient Name */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Patient Name:
              </label>
              <input
                type="text"
                placeholder="Enter patient name"
                value={filters.patientName}
                onChange={(e) => setFilters({...filters, patientName: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            {/* Start Date */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Start Date:
              </label>
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) => setFilters({...filters, startDate: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            {/* End Date */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                End Date:
              </label>
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) => setFilters({...filters, endDate: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            {/* Received Start Date */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Received Start Date:
              </label>
              <input
                type="date"
                value={filters.receivedStartDate}
                onChange={(e) => setFilters({...filters, receivedStartDate: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            {/* Received End Date */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Received End Date:
              </label>
              <input
                type="date"
                value={filters.receivedEndDate}
                onChange={(e) => setFilters({...filters, receivedEndDate: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            {/* Modality */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Modality:
              </label>
            
              <input
                type="text"
                placeholder="Search modality..."
                value={searchTerms.modality}
                onChange={(e) =>
                  setSearchTerms({ ...searchTerms, modality: e.target.value })
                }
                className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-lg"
              />
            
              <select
                multiple
                value={filters.modality}
                onChange={(e) => {
                  const selected = Array.from(
                    e.target.selectedOptions,
                    option => option.value
                  );
                  setFilters({ ...filters, modality: selected });
                }}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                size="4"
              >
                {[...modalities]
                  .filter(mod =>
                    mod.toLowerCase().includes(searchTerms.modality.toLowerCase())
                  )
                  .sort((a, b) => a.localeCompare(b))
                  .map(mod => (
                    <option key={mod} value={mod}>
                      {mod}
                    </option>
                  ))}
              </select>
            </div>

            {/* Radiologist */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Radiologist:
              </label>
            
              {/* search box */}
              <input
                type="text"
                placeholder="Search radiologist..."
                value={searchTerms.radiologist}
                onChange={(e) =>
                  setSearchTerms({ ...searchTerms, radiologist: e.target.value })
                }
                className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-lg"
              />
            
              {/* dropdown */}
              <select
                multiple
                value={filters.radiologist}
                onChange={(e) => {
                  const selected = Array.from(
                    e.target.selectedOptions,
                    option => option.value
                  );
                  setFilters({ ...filters, radiologist: selected });
                }}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                size="4"
              >
                {[...radiologists]
                  .filter(rad =>
                    `${rad.name} ${rad.email}`
                      .toLowerCase()
                      .includes(searchTerms.radiologist.toLowerCase())
                  )
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(rad => (
                    <option key={rad.id} value={rad.id}>
                      {rad.name} ({rad.email})
                    </option>
                  ))}
              </select>
            
              <p className="text-xs text-gray-500 mt-1">
                Hold Ctrl/Cmd to select multiple
              </p>
            </div>
            {/* Status */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Status:
              </label>
              <select
                value={filters.status}
                onChange={(e) => setFilters({...filters, status: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="All">All</option>
                <option value="Reported">Reported</option>
                <option value="Pending">Pending</option>
              </select>
            </div>
            {/* Institution */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Institution Name:
              </label>
            
              <input
                type="text"
                placeholder="Search institution..."
                value={searchTerms.institution}
                onChange={(e) =>
                  setSearchTerms({ ...searchTerms, institution: e.target.value })
                }
                className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-lg"
              />
            
              <select
                multiple
                value={filters.institution}
                onChange={(e) => {
                  const selected = Array.from(
                    e.target.selectedOptions,
                    option => option.value
                  );
                  setFilters({ ...filters, institution: selected });
                }}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                size="4"
              >
                {[...institutions]
                  .filter(inst =>
                    inst.name
                      .toLowerCase()
                      .includes(searchTerms.institution.toLowerCase())
                  )
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(inst => (
                    <option key={inst.name} value={inst.name}>
                      {inst.name}
                    </option>
                  ))}
              </select>
            </div>

          </div>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4">
            <button
              disabled={!hasAtLeastOneFilter()}
              onClick={handleApplyFilters}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors
                ${hasAtLeastOneFilter() ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
            >
              <Filter size={20} /> Apply Filters
            </button>
   <button
              onClick={calculateBilling}
              disabled={billingLoading || patients.length === 0}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors
                ${billingLoading || patients.length === 0 
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                  : 'bg-purple-600 hover:bg-purple-700 text-white'}`}
            >
              {billingLoading ? 'Calculating...' : 'Calculate Bill'}
            </button>
            <button
              onClick={doctorBilling}
              disabled={billingLoading || patients.length === 0}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors
                ${billingLoading || patients.length === 0 
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                  : 'bg-purple-600 hover:bg-purple-700 text-white'}`}
            >
              {billingLoading ? 'Calculating...' : 'Calculate doctor Bill'}
            </button>
           
            <button
              onClick={handleExportExcel}
              className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
            >
              <Download size={20} /> Get Excel
            </button>
            <button
  onClick={handleExportBillingExcel}
  className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
>
  <Download size={20} />
  Get client Billing Excel
</button>
           <button
  onClick={handleExportDoctorBillingExcel}
  className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
>
  <Download size={20} />
  Get doctor Billing Excel
</button>
            <button
              onClick={handleResetFilters}
              className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
            >
              <RotateCcw size={20} /> Reset Filters
            </button>
            {/* <button
  onClick={handleExportExcelfrontend}
  className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
>
  <Download size={20} /> Get Billing Excel
</button> */}
          </div>
        </div>
        

            {/* Table Section */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold text-gray-800">
              Patient Records ({patients.length})
            </h2>
               {billingData && showBilling && (
              <div className="bg-purple-100 text-purple-800 px-6 py-3 rounded-lg font-semibold">
                Total Bill Amount: {formatCurrency(billingData.total_amount)}
                {billingData.failed_count > 0 && (
                  <span className="ml-2 text-sm text-red-600">
                    ({billingData.failed_count} failed)
                  </span>
                )}
              </div>
            )}
        
          </div>
    {loading ? (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
              <p className="mt-4 text-gray-600">Loading patient records...</p>
            </div>
          ) : filteredPatients.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              <Search size={48} className="mx-auto mb-4 opacity-50" />
              <p className="text-lg">No patient records found</p>
              <p className="text-sm">Try adjusting your search filters</p>
            </div>
          ): (
          <div className="overflow-x-auto">
  <table className="w-full border-collapse">
    <thead>
      <tr className="bg-gray-100 border-b-2 border-gray-300">
      
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Patient Name</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Patient ID</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Age/Gender</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Study Date</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Received On</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Modality</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Institution</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Study Description</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Body Part</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Views</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Status</th>
        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Radiologists</th>
        {/* New Billing Column - Only show when billing data is available */}
         {billingData && showBilling && (
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 bg-purple-50">
                        Bill Amount
                      </th>
                    )}
      </tr>
    </thead>
    

   <tbody>
                  {filteredPatients.map(patient => {
                    const patientIndex = patients.findIndex(p => p.id === patient.id);
                    const patientBill = billingData?.patients_map?.[patientIndex];
                    
                    return (
                      <tr key={patient.id} className="border-b hover:bg-gray-50 transition-colors">
                        <td className="px-4 py-3 text-sm">{patient.patient_name}</td>
                        <td className="px-4 py-3 text-sm font-mono">{patient.patient_id}</td>
                        <td className="px-4 py-3 text-sm">{patient.age} / {patient.gender}</td>
                        <td className="px-4 py-3 text-sm">{patient.study_date || 'N/A'}</td>
                        <td className="px-4 py-3 text-sm">{formatDate(patient.recived_on_db)}</td>
                        <td className="px-4 py-3 text-sm">
                          <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                            {patient.Modality || 'N/A'}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-sm">{patient.institution_name}</td>
                        <td className="px-4 py-3 text-sm">
                          {patient.study_description || 'N/A'}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {patient.body_part_examined || 'N/A'}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {patient.imaging_views || 'N/A'}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          <span
                            className={`px-2 py-1 rounded text-xs font-medium ${
                              patient.isDone
                                ? 'bg-green-100 text-green-800'
                                : 'bg-yellow-100 text-yellow-800'
                            }`}
                          >
                            {patient.isDone ? 'Reported' : 'Pending'}
                          </span>
                          {patient.urgent && (
                            <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 rounded text-xs font-medium">
                              Urgent
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {patient.radiologists.length > 0
                            ? patient.radiologists.join(', ')
                            : 'Not assigned'}
                        </td>
                        {billingData && showBilling && (
                          <td className="px-4 py-3 text-sm bg-purple-50">
                            {(() => {
                              if (!patientBill) {
                                return <span className="text-gray-400">N/A</span>;
                              }
                              
                              if (patientBill.success) {
                                return (
                                  <div>
                                    <span className="font-semibold text-purple-700">
                                      {formatCurrency(patientBill.price)}
                                    </span>
                                    {patientBill.night_charge_applied && (
                                      <span className="ml-2 text-xs bg-purple-200 text-purple-800 px-2 py-1 rounded">
                                        Night Charge
                                      </span>
                                    )}
                                    <div className="text-xs text-gray-500 mt-1">
                                      Client: {patientBill.client_name}
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div>
                                    <span className="text-red-500 text-xs">Failed: {patientBill.error}</span>
                                  </div>
                                );
                              }
                            })()}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
  </table>

  {nextCursor && (
    <div className="text-center mt-6">
      <button
        onClick={handleLoadMore}
        className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold transition-colors"
      >
        Load More
      </button>
    </div>
  )}
</div>
          )}
        </div>
     
      </div>
    </div>
  );
}
